var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17387 4.99929L9.75374 1.42723C10.0802 1.10073 10.0802 0.571374 9.75374 0.244875C9.42729 -0.0816249 8.898 -0.0816249 8.57155 0.244875L5 3.82526L1.42845 0.244875C1.102 -0.0816248 0.572714 -0.0816248 0.246261 0.244875C-0.0801924 0.571374 -0.0801924 1.10073 0.246261 1.42723L3.82613 4.99929L0.246261 8.57135C0.0886524 8.72769 0 8.94051 0 9.16253C0 9.38454 0.0886524 9.59736 0.246261 9.7537C0.402582 9.91133 0.615373 10 0.837356 10C1.05934 10 1.27213 9.91133 1.42845 9.7537L5 6.17332L8.57155 9.7537C8.72787 9.91133 8.94066 10 9.16264 10C9.38463 10 9.59742 9.91133 9.75374 9.7537C9.91135 9.59736 10 9.38454 10 9.16253C10 8.94051 9.91135 8.72769 9.75374 8.57135L6.17387 4.99929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose4);
export default __webpack_public_path__ + "static/media/icon-close-4.7d161b8dcd15fd15ed743f7846cb73b2.svg";
export { ForwardRef as ReactComponent };